import { Routes, Route } from "react-router-dom";
import { useState } from "react";

import LoginScreen from "./LoginScreen";
import DashboardLayout from "./components/DashboardLayout";
import DashboardPage from "./pages/DashboardPage";

import Brands from "./pages/Products/Brands";
import Categories from "./pages/Products/Categories";
import SubCategories from "./pages/Products/SubCategories";
import Products from "./pages/Products/Products";
import Sizes from "./pages/Products/Sizes";

import Agents from "./pages/Agents";
import AgentsView from "./pages/AgentsView";
import Customers from "./pages/Customers";
import CustomersView from "./pages/CustomersView";

import Orders from "./pages/Orders";

import ChangePassword from "./components/ChangePassword";
import Profile from "./components/Profile";

import PrivateRoute from "./routes/PrivateRoute";
import OrderView from "./pages/OrderView";
import Referrals from "./pages/Referrals";
import DownloadApk from "./pages/DownloadApk";

const App = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  return (
    <Routes>
      {/* PUBLIC ROUTE */}
      <Route path="/" element={<LoginScreen />} />
      {/* DOWNLOAD APK */}
      <Route path="/download-apk" element={<DownloadApk />} />

      {/* PROTECTED ROUTES */}
      <Route element={<PrivateRoute />}>
        <Route
          element={
            <DashboardLayout
              isMobileOpen={isMobileOpen}
              setIsMobileOpen={setIsMobileOpen}
            />
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />

          {/* PRODUCTS */}
          <Route path="/products/brands" element={<Brands />} />
          <Route path="/products/categories" element={<Categories />} />
          <Route path="/products/sub-categories" element={<SubCategories />} />
          <Route path="/products/products" element={<Products />} />
          <Route path="/products/sizes" element={<Sizes />} />

          {/* AGENTS */}
          <Route path="/sales-agents" element={<Agents />} />
          <Route path="/agents-view" element={<AgentsView />} />

          {/* CUSTOMERS */}
          <Route path="/customers" element={<Customers />} />
          <Route path="/customers-view/:id" element={<CustomersView />} />

          {/* ORDERS */}
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:orderId" element={<OrderView />} />

          {/* REFERRALS */}
          <Route path="/referrals" element={<Referrals />} />

          {/* PROFILE */}
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/profile" element={<Profile />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default App;
